import { ref, watch } from "vue";

const errors = {
  "auth/invalid-email": `Invalid email`,
  "auth/wrong-password": `Incorrect password`,
  "auth/missing-password": `Please enter a password`,
  "auth/weak-password": `Please enter a stronger password`,
  "auth/missing-not-found": `No account exists with this email`,
  "auth/email-already-in-use": `An account already exists with this email`,
  "auth/passwords-don't-match": `The supplied passwords do not match`,
  "auth/user-not-found": `An account is not associated with that email`,
  "auth/network-request-failed": `Check your internet connection`,
  "auth/cancelled-popup-request": `Google sign-in window closed`,
  "auth/too-many-request": `Too many requests, please try again later`,
  "auth/missing-email": `Please enter an email address`,
  "auth/internal-error": `authentification cannot be completed at this
  time, please try again later or contact support`,
};

export function useError() {
  const errorMessage = ref("");

  const processError = (error) => {
    errorMessage.value = errors[error.code] ?? error.code;
  };

  watch(errorMessage, (oldValue, newValue, onInvalidate) => {
    const clearError = setTimeout(() => (errorMessage.value = ""), 5000);
    onInvalidate(() => clearInterval(clearError));
  });

  return {
    errorMessage,
    processError,
  };
}
